/**
 * ローディング画面管理を行います
 *
 * 複数のAPIが並列実行される場合でも、すべてのAPIが完了するまでローディングを
 * 表示し続けるために、リファレンスカウンター方式を採用しています。
 * startLoadingDisplay() を呼ぶたびにカウントが増加し、
 * endLoadingDisplay() を呼ぶたびに減少します。
 * カウントが0になったときのみローディングを非表示にします。
 */
"use strict";
/** 現在実行中のローディングリクエスト数 */
let loadingCount = 0;
export const startLoadingDisplay = () => {
    loadingCount++;
    let loading = document.getElementById('Loading');
    if (loading) {
        // loaderクラスを復元（axiosActionとの互換性のため）
        if (!loading.classList.contains('loader')) {
            loading.classList.add('loader');
        }
        // CSSで設定されたスタイルをリセット
        loading.style.visibility = 'visible';
        loading.style.opacity = '1';
        loading.style.zIndex = '9999';
        loading.style.display = 'flex';
    }
};
export const endLoadingDisplay = () => {
    // カウントを減らし、0未満にならないようにする
    loadingCount = Math.max(0, loadingCount - 1);
    // まだ実行中のローディングリクエストがある場合は非表示にしない
    if (loadingCount > 0) {
        return;
    }
    let loading = document.getElementById('Loading');
    if (loading) {
        // より確実に非表示にするため、複数の方法で設定
        loading.style.display = 'none';
        loading.style.visibility = 'hidden';
        loading.style.opacity = '0';
        loading.style.zIndex = '-1';
        // クラスからも削除してCSSの競合を回避
        loading.classList.remove('loader');
    }
};
